import * as actions from "actions";
import { getNotifications, readWebNotification } from "Api";

export const fetchWebNotifications = () => {
  return (dispatch, getState) => {
    const { token, currentClient } = getState().auth;

    let clientId = currentClient ? currentClient.id : null;

    return dispatch(
      actions.fetchWebNotifications(getNotifications(token, clientId))
    );
  };
};

export const readNotification = notificationId => {
  return (dispatch, getState) => {
    const { token } = getState().auth;

    return dispatch(
      actions.readNotification(
        readWebNotification(token, notificationId).then(res => {
          return res.data.data;
        }, err => err)
      )
    );
  };
};



// WEBPACK FOOTER //
// ./src/actions/thunks/notifications.js